import type { RatingState } from "@esgt/event-store"
import type { submissionProgressPerspective } from "@esgt/helpers"
import type { DataFilesProcessingStatus, RatingProfileConfig, RatingType } from "@esgt/types"
import type { RatingProfileAndRevisionQuery } from "lib/generated/graphql"
import type { UseMethodResult } from "lib/hooks"
import { createContext } from "react"

export const RatingContext = createContext<{
  ratingId: string
  ratingState?: RatingState
  ratingProfile: RatingProfileAndRevisionQuery["ratingProfile"]
  method: UseMethodResult["method"]
  ratingProfileConfig: RatingProfileConfig
  fetching: boolean
  isReady: boolean
  isEditable: boolean
  isReadyForCompletion: boolean
  submissionProgress?: ReturnType<typeof submissionProgressPerspective>
  ratingType: RatingType
  isFree: boolean
  upgradedToFull: boolean
  dataFilesProcessingStatus: DataFilesProcessingStatus
}>({ fetching: false } as any)
